import { Injectable } from "@angular/core";
import { RestService } from "../../../services/rest.service";
import { CreateOrderDto } from "../dto/create-order.dto";
import { CreateOrderQuoteDto, OrderQuote } from "../dto/create-order-quote.dto";
import { AutoRenewMandate } from "../interface/auto-renew-mandate.interface";
import { Order } from "../interface/order.interface";

@Injectable({
    providedIn: 'root'
})
export class OrderApi {

    public static readonly ApiEndpoint = 'order/';

    constructor(private restService: RestService) { }

    public async readOne(orderId: string) {
        return this.restService.send<Order>({
            url: OrderApi.ApiEndpoint + orderId,
            method: "GET"
        })
    }

    public async quote(dto: CreateOrderQuoteDto) {
        return this.restService.send<OrderQuote>({
            url: OrderApi.ApiEndpoint + 'quote',
            method: 'POST',
            body: dto,
        });
    }

    public async createSubscriptionOrder(createOrderDto: CreateOrderDto) {
        return this.restService.send<Order>({
            url: OrderApi.ApiEndpoint + 'subscription-order',
            method: "POST",
            body: createOrderDto
        })
    }

    public async linkRazorpay(orderId: string) {
        return this.restService.send<Order>({
            url: OrderApi.ApiEndpoint + 'link-razorpay/' + orderId,
            method: "POST",
        })
    }

    public async recheckPayment(orderId: string) {
        return this.restService.send<Order>({
            url: OrderApi.ApiEndpoint + orderId + '/recheck-payment',
            method: "POST",
        })
    }

    public async readAutoRenew(): Promise<AutoRenewMandate[]> {
        return (await this.restService.send<AutoRenewMandate[]>({
            url: OrderApi.ApiEndpoint + 'auto-renew',
            method: 'GET',
        })).data || [];
    }

    public async cancelAutoRenew(razorpaySubscriptionId: string): Promise<void> {
        await this.restService.send({
            url: OrderApi.ApiEndpoint + 'auto-renew/' + razorpaySubscriptionId,
            method: 'DELETE',
        });
    }

}